import { useCallback, useState, type ReactNode } from 'react';
import { HelpContext } from './helpContext';

/** Provides the in-app help drawer open/close state to the app shell (per
 *  frontend-ui-system.md § In-app help system). */
export function HelpProvider({ children }: { children: ReactNode }) {
  const [isOpen, setIsOpen] = useState(false);
  const open = useCallback(() => setIsOpen(true), []);
  const close = useCallback(() => setIsOpen(false), []);
  return <HelpContext.Provider value={{ isOpen, open, close }}>{children}</HelpContext.Provider>;
}
